export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        description: entity.description || '',
        type: entity.type || 'email',
        value: entity.value || ''
    };
};
